<script>
  import { onMount, beforeUpdate } from 'svelte';
  
  export let form_id = null;
  export let root = null;
  export let itemsForPrintFn = null;
  export let operator = null;
  
  let current_form_id = null;
  let items = [];
  let updated_at = null;
  
  $: items_for_print = itemsForPrintFn == null ? items : itemsForPrintFn(items, operator, updated_at)
  
  function fetchItems() {
    items = [];
    if (!form_id) return;
    fetch(`/data/${form_id}/data.json`)
      .then(r => r.json())
      .then(data => {
        items = [];
        updated_at = new Date(data.updated_at);
        if (root && data.data) {
          if (data.data[root])
            items = data.data[root];
        }
        else if (data.data)
          items = [data.data];
      });
      items_for_print = itemsForPrintFn(items, operator, updated_at);
    current_form_id = form_id;
  }
  
  onMount(fetchItems);
  
  beforeUpdate(() => {
    if (form_id != current_form_id) fetchItems();
  });
</script>
{#if items_for_print && items_for_print.length}
{#each items_for_print as item, i}
<slot index='{i}' item='{item}' updated_at='{updated_at}'></slot>
{/each}
{/if}
